var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVitalLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147,
    height: 48,
    viewBox: "0 0 147 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#436AB2",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.586 14.414L17.07 38.838 7.558 14.414H0l13.293 32.59h7.623l13.293-32.59zM45.398 47.004h7.086v-32.59h-7.086v32.59zM44.52 4.631c0-2.43 2.024-4.386 4.386-4.386a4.377 4.377 0 0 1 4.386 4.386 4.378 4.378 0 0 1-4.386 4.386c-2.362 0-4.386-1.959-4.386-4.386zM69.819 39.448V20.621h-5.4v-6.207h5.4V5.507h7.085v8.907h6.61v6.207h-6.61v17.07c0 2.228 1.08 3.849 3.103 3.849 1.35 0 2.632-.54 3.172-1.15l1.686 5.333c-1.28 1.212-3.373 2.091-6.68 2.091-5.464 0-8.366-2.971-8.366-8.366M116.57 34.657c-1.621-2.227-4.658-3.375-7.76-3.375-3.98 0-6.951 2.294-6.951 5.87 0 3.508 2.971 5.804 6.95 5.804 3.103 0 6.14-1.15 7.76-3.377v-4.922zm0 8.84c-2.432 2.762-6.21 4.318-10.528 4.318-5.33 0-11.332-3.578-11.332-10.798 0-7.489 6.003-10.592 11.332-10.592 4.388 0 8.166 1.416 10.528 4.184V25.75c0-3.778-3.103-6.072-7.626-6.072-3.643 0-6.815 1.348-9.648 4.115l-2.902-4.926c3.778-3.575 8.502-5.264 13.696-5.264 7.22 0 13.565 3.037 13.565 11.81v21.591h-7.085v-3.508zM139.566 47.004h7.085V1.999h-7.085z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitalLogo);
export default __webpack_public_path__ + "static/media/vitalLogo.1450efd8d3b65cd877b7d75d18c1a574.svg";
export { ForwardRef as ReactComponent };